import { useAllTasksFilterDocument } from 'features/user';
import React, { useRef } from 'react';
import { TaskFilterList } from 'shared/views/task-filter-list';

import * as Styled from './all-tasks.style';
import { MobileAddTaskButton } from './components/mobile-add-task-button';
import { PageTopBar } from './components/page-top-bar';
import { useCustomOrderByGrouping } from './hooks/use-custom-order-by-grouping';
import { useOnReorder } from './hooks/use-on-reorder';
import { useOnSectionCollapse } from './hooks/use-on-section-collapse';

export const AllTasks: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const filterDocument = useAllTasksFilterDocument();
  const customOrder = useCustomOrderByGrouping(filterDocument.groupByMode);
  const updateCustomOrder = useOnReorder(filterDocument.groupByMode);
  const updateCollapsedSections = useOnSectionCollapse();

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />

          <Styled.Content ref={scrollRef}>
            <TaskFilterList
              scrollElement={scrollRef}
              filterDocument={filterDocument}
              customOrder={customOrder}
              onReorder={updateCustomOrder}
              onSectionCollapse={updateCollapsedSections}
            />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>

      <MobileAddTaskButton />
    </Styled.Container>
  );
};
